import * as React from 'react';
import ListContainer from '../ListContainer';
import ExpandIcon from '../Utils/ExpandIcon';
import { ConfigurableItemDto } from '../ListItem';
import { ConfigureSectionDto } from '../AccordionContainer';
import { StyledAccordionContainer } from '../ConfigurePage.styles';
import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';

export interface AncillaryHoursSectionDto {
    name: string;
    whatDidYouDo: ConfigureSectionDto;
    howLongDidItTake: ConfigureSectionDto;
}

interface AncillaryHoursSectionProps {
    dto: AncillaryHoursSectionDto;
    isExpanded: boolean;
    expandedPanels: string[];
    onExtendedPanelsChange: (isExpanded: boolean, panel: string) => void;
}

const AncillaryHoursSection = (props: AncillaryHoursSectionProps) => {
    const { name, whatDidYouDo, howLongDidItTake } = props.dto;
    const { onExtendedPanelsChange, isExpanded, expandedPanels } = props;

    //Data from dto
    const configurableItems: ConfigurableItemDto[] = [];
    const innerSections: ConfigureSectionDto[] = [whatDidYouDo, howLongDidItTake];

    return (
        <StyledAccordionContainer
            expanded={isExpanded}
            disableGutters={true}
            onChange={(_: unknown, isExpanded: boolean) =>
                onExtendedPanelsChange(isExpanded, name)
            }>
            <AccordionSummary expandIcon={<ExpandIcon isExpanded={isExpanded} />}>
                <Typography variant="h3">{'Invoice & Payroll - Ancillary Hours'}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <ListContainer
                    parentPanel={name}
                    expandedPanels={expandedPanels}
                    handleChange={onExtendedPanelsChange}
                    configurableItems={configurableItems ?? []}
                    innerSections={innerSections ?? []}
                />
            </AccordionDetails>
        </StyledAccordionContainer>
    );
};

export default AncillaryHoursSection;
